import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../css/Projects.css";
import { Carousel } from "react-responsive-carousel";
import Axios from "axios";
import { URL_ONE } from "../configs/defaultURL";
import { useDispatch, useSelector } from "react-redux";
import { SET_PROJECT } from "../../redux/types/types";
import ReactIcon from "../icons/reactIcon.png";
import JavaScriptIcon from "../icons/javascriptIcon.png";
import CorePHPIcon from "../icons/phpIcon.png";
import JQueryIcon from "../icons/jqueryIcon.png";
import HTMLIcon from "../icons/htmlIcon.png";
import CSSIcon from "../icons/cssIcon.png";
import CSharpIcon from "../icons/csharpIcon.png";
import MongoDBIcon from "../icons/mongoDBIcon.png";
import MysqlIcon from "../icons/mysqlIcon.png";
import RestIcon from "../icons/restAPIIcon.png";
import ReduxIcon from "../icons/reduxIcon.png";
import NodeJSIcon from "../icons/nodejsIcon.png";
import ASPIcon from "../icons/aspIcon.png";
import MssqlIcon from "../icons/mssqlIcon.png";
import SQLiteIcon from "../icons/sqliteIcon.png";
import ExpressJSIcon from "../icons/expressjsIcon.png";
import CodeIgniterIcon from "../icons/codeIgniterIcon.png";
import Web from "@material-ui/icons/LanguageOutlined";
import Mobile from "@material-ui/icons/Smartphone";
import MobileAndroid from "@material-ui/icons/PhoneAndroid";
import MobileIphone from "@material-ui/icons/PhoneIphone";
import Desktop from "@material-ui/icons/DesktopWindows";
import ArrowBack from "@material-ui/icons/KeyboardArrowLeftOutlined";
import { Link } from "react-router-dom";
import myprojects from "../data/myprojects.project_details.json";

function Projects() {
  const { projectID } = useParams();

  const dispatch = useDispatch();
  const initialProject = useSelector((state) => state.initialProject);

  const navigate = useNavigate();

  useEffect(() => {
    const currentproject = myprojects.filter(
      (flt) => flt.projectID === projectID
    );
    if (currentproject.length > 0) {
      dispatch({ type: SET_PROJECT, initialproject: currentproject[0] });
      return;
    }

    navigate("/");
    // Axios.get(`${URL_ONE}/project/${projectID}`)
    //   .then((response) => {
    //     // console.log(response.data);
    //     dispatch({ type: SET_PROJECT, initialproject: response.data });
    //   })
    //   .catch((err) => {
    //     //catch error alert
    //   });
  }, [projectID]);

  const openWindow = (published, link) => {
    if (published) {
      window.open(link, "_blank");
    }
  };

  const openWindowPlat = (linker) => {
    window.open(linker, "_blank");
  };

  return (
    <div id="div_projects">
      <div id="back_div">
        <Link to="/#works">
          <button id="btn_back">
            <ArrowBack style={{ fontSize: "30px" }} />
          </button>
        </Link>
      </div>
      <div id="top_navigations_projects">
        {/* <p id='title_label_tag'>{initialProject.title}</p> */}
        <div id="carousel_holder">
          <Carousel
            width="100%"
            infiniteLoop={true}
            dynamicHeight={true}
            showThumbs={false}
          >
            <div
              style={{
                backgroundImage: `url(${initialProject.image})`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
              }}
              className="img_holder_carousel"
            />
            {initialProject.gallery.map((gls, i) => {
              if (gls.type == "image") {
                return (
                  <div
                    key={i}
                    style={{
                      backgroundImage: `url(${gls.link})`,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                    }}
                    className="img_holder_carousel"
                  />
                );
              }
            })}
          </Carousel>
        </div>
      </div>
      <div id="details_navigations_projects">
        <button
          disabled={!initialProject.published}
          id="btn_link_openner"
          onClick={() => {
            openWindow(initialProject.published, initialProject.link);
          }}
        >
          {initialProject.published ? "Visit" : "Not Published"}
        </button>
        <p id="title_label_tag">{initialProject.title}</p>
        <p id="categories_tag">
          {initialProject.categories.map((cat, i) => {
            return (
              <span key={i} className="categories_indv">
                <img
                  src={
                    cat.split(" ").join("") == "CorePHP"
                      ? CorePHPIcon
                      : cat.split(" ").join("") == "ReactJS"
                      ? ReactIcon
                      : cat.split(" ").join("") == "ReactNative"
                      ? ReactIcon
                      : cat.split(" ").join("") == "VanillaJavaScript"
                      ? JavaScriptIcon
                      : cat.split(" ").join("") == "JQuery"
                      ? JQueryIcon
                      : cat.split(" ").join("") == "HTML5"
                      ? HTMLIcon
                      : cat.split(" ").join("") == "HTML"
                      ? HTMLIcon
                      : cat.split(" ").join("") == "CSS"
                      ? CSSIcon
                      : cat.split(" ").join("") == "C#/.NETFramework"
                      ? CSharpIcon
                      : cat.split(" ").join("") == "MongoDB"
                      ? MongoDBIcon
                      : cat.split(" ").join("") == "MySQL"
                      ? MysqlIcon
                      : cat.split(" ").join("") == "RestAPI"
                      ? RestIcon
                      : cat.split(" ").join("") == "Redux"
                      ? ReduxIcon
                      : cat.split(" ").join("") == "ASP.Net"
                      ? ASPIcon
                      : cat.split(" ").join("") == "MicrosoftSQL"
                      ? MssqlIcon
                      : cat.split(" ").join("") == "SQLite"
                      ? SQLiteIcon
                      : cat.split(" ").join("") == "ExpressJS"
                      ? ExpressJSIcon
                      : cat.split(" ").join("") == "CodeIgniter"
                      ? CodeIgniterIcon
                      : cat.split(" ").join("") == "NodeJS"
                      ? NodeJSIcon
                      : ""
                  }
                  className="icon_skills"
                />
                {cat}
              </span>
            );
          })}
        </p>
        {initialProject.description.map((pargs, i) => {
          return (
            <p key={i} className="p_listing">
              {pargs}
            </p>
          );
        })}
        <p className="label_sections_projects">Platforms</p>
        <div id="platforms_holder">
          <nav id="nav_platforms">
            {initialProject.platforms.map((plts, i) => {
              return (
                <li key={i} className="li_platforms">
                  <div className="div_platform_identifier">
                    <div className="div_dos_id">
                      <p className="tag_plt_name">
                        {plts.platform_title} -{" "}
                        {plts.platform_name == "Web" ? (
                          <Web style={{ fontSize: "20px" }} />
                        ) : plts.platform_name == "Mobile Devices" ? (
                          <Mobile style={{ fontSize: "20px" }} />
                        ) : plts.platform_name == "Desktop" ? (
                          <Desktop style={{ fontSize: "20px" }} />
                        ) : plts.platform_name == "Android" ? (
                          <MobileAndroid style={{ fontSize: "20px" }} />
                        ) : plts.platform_name == "Ios" ? (
                          <MobileIphone style={{ fontSize: "20px" }} />
                        ) : (
                          ""
                        )}
                        {plts.platform_name}
                      </p>
                      <p className="tag_desc">{plts.platform_desc}</p>
                      <span id="btns_span">
                        {plts.platform_site == "none" ? (
                          ""
                        ) : (
                          <button
                            className="btn_plt"
                            onClick={() => {
                              openWindowPlat(plts.platform_site);
                            }}
                          >
                            Visit Site
                          </button>
                        )}
                        {plts.platform_repo == "none" ? (
                          ""
                        ) : (
                          <button
                            className="btn_plt"
                            onClick={() => {
                              openWindowPlat(plts.platform_repo);
                            }}
                          >
                            Repository
                          </button>
                        )}
                      </span>
                    </div>
                  </div>
                </li>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Projects;
